import { SetType } from '@/components/Template/types';

export const SET_DEFAULTS: Record<
  SetType,
  { name: string; appDisplayName: string; setType: 'Word' | 'Sentence' }
> = {
  wordsets: {
    name: 'Neues Wörterset',
    appDisplayName: 'Wörter',
    setType: 'Word',
  },
  sentencesets: {
    name: 'Neues Sätzeset',
    appDisplayName: 'Sätze',
    setType: 'Sentence',
  },
  textsets: {
    name: 'Neues Texteset',
    appDisplayName: 'Texte',
    setType: 'Word',
  },
};
